import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import {
  AFFILIATE_API_PERMISSIONS,
  AFFILIATE_API_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_API,
} from '@modules/affiliate-api/constants';
import { getTranslationKeys } from '@modules/affiliate-api/translations';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import { AFFILIATE_TRACKING_LINKS_MENU_ITEM, TRANSLATION_GROUP_SIDEBAR } from '@modules/sidebar/constants';

export class AffiliateApiModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAffiliateRoute({
      name: AFFILIATE_API_ROUTE_NAME,
      path: 'affiliate-api',
      permission: AFFILIATE_API_PERMISSIONS.SHOW,
      component: () => import('@modules/affiliate-api/pages/AffiliateApiPage/AffiliateApiPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAffiliateMenuItem(AFFILIATE_TRACKING_LINKS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'TRACKING_LINKS_AFFILIATE_API'),
      to: {
        name: AFFILIATE_API_ROUTE_NAME,
      },
      permission: AFFILIATE_API_PERMISSIONS.SHOW,
      id: AFFILIATE_API_ROUTE_NAME,
      order: 50,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_API, getTranslationKeys);
  }
}
